import React, { useRef, useState, useEffect, useCallback, memo } from "react";
import { useLanguageContext } from "../../../Context/LanguageContext";
import DoneIcon from "@mui/icons-material/Done";
import RenderRow from "./RenderRow";
import { useMainGridSortActionContext } from "../../../Context/GlobalContext";
import TableHeader from "./TableHeader";
import { DataGrid } from "@mui/x-data-grid";

const GridTable = memo((props) => {
  const UpdateSortBy = useMainGridSortActionContext();
  const { data, handleAction, handleCheckBoxClick, pageInfo, reportCode } =
    props;

  const handleHeaderClick = useCallback((itemName) => {
    UpdateSortBy(itemName);
  }, []);

  return (
    <table className="table table-striped table-hover table-sticky">
      <TableHeader
        headers={data.headers}
        headerName={data.headerName}
        handleHeaderClick={handleHeaderClick}
        pageInfo={data.pageInfo}
      />
      <TableBody
        data={data.data}
        headers={data.headerName}
        headerList={data.headers}
        handleAction={handleAction}
        handleCheckBoxClick={handleCheckBoxClick}
        reportCode={reportCode}
      />
    </table>
  );
});

const TableBody = memo(
  ({
    data,
    headers,
    headerList,
    handleAction,
    handleCheckBoxClick,
    reportCode,
  }) => {
    const { localization } = useLanguageContext();
    const buttonRef = useRef(null);

    return (
      <>
        {data.length > 0 ? (
          <tbody ref={buttonRef}>
            {data.map((item, index) => (
              <RenderRow
                rowData={item}
                headerList={headerList}
                index={index}
                key={"key" + index}
                handleAction={handleAction}
                handleCheckBoxClick={handleCheckBoxClick}
                reportCode={reportCode}
              />
            ))}
          </tbody>
        ) : (
          <tbody ref={buttonRef}>
            <tr>
              <td colSpan="100%">{localization.noRecordFound}</td>
            </tr>
          </tbody>
        )}
      </>
    );
  }
);
// const GridTable = memo((props) => {
//   return <DataGrid columns={enhancedColumns} rows={rows} />;
// });
export default memo(GridTable);
